import React from 'react'
import url from 'front-end-core/core/url'
import { QA_CONTENT } from 'constants/controllers'
import QaResultsItemQuestionContainer from 'redux/containers/components/search/results-item/QaResultsItemQuestionContainer'
import QaResultPathBreadCrumbsContainer from 'redux/containers/components/search/results-item/QaResultPathBreadCrumbsContainer'
import QaResultsItemExcerpt from 'components/search/results-item/QaResultsItemExcerpt'
import { useSelector } from 'react-redux'
import selectFlavour from 'redux/selectors/selectFlavour'
import selectAolName from 'redux/selectors/selectAolName'

const QaResultsItem = ({
  questionNumber = '',
  question,
  answer,
  path = [],
  truncated = false,
  tocId: focusedId
}) => {
  const [section] = path
  if (!section) { return null }
  const sectionId = section.id
  const xmlProps = { sectionId }
  const flavour = useSelector(selectFlavour)
  const aol = useSelector(selectAolName)
  const questionUrl = url(QA_CONTENT, { aol, flavour, sectionId, focusedId, highlight: 'hl' })

  return (
    <li className='mt7 mb3'>
      <QaResultsItemQuestionContainer {...{ questionNumber, question, questionUrl, xmlProps }} />
      <QaResultPathBreadCrumbsContainer {...{ path }} />
      <QaResultsItemExcerpt {...{ truncated, answer, xmlProps }} />
    </li>
  )
}

export default QaResultsItem
